import React, { useState, useEffect, useRef } from 'react'
import { Box } from '@chakra-ui/react';
import { optionTypes } from "../types/subWidgetOptionsTypes";
import InputTextAreaExpandableWithFormatting from '../../../../forms/TextareaField/components/InputTextAreaExpandableWithFormatting';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { isQuillDeltaFormat } from '../../../../global/helpers/global-helpers';
import LaunchdeckInputTextArea from '../../../../forms/TextareaField/components/LaunchdeckInputTextArea';
import LaunchdeckDisplayTextArea from '../../../../forms/TextareaField/components/LaunchdeckDisplayTextArea';


export const NormalText = ({
  subWidgetId,
  editableItemId,
  options,
  setSubWidgetContent,
  subWidgetContent,
  isDragging,
  handleEditItemByClick,
  handleSaveItemByClickOutside
}) => {

  const quillRef = useRef(null);
  const [isQuillDisplay, setIsQuillDisplay] = useState(true)
  const [isFocused, setIsFocused] = useState(false);

   useEffect(() => {
     if (subWidgetContent) {
      const isDeltaFormat = isQuillDeltaFormat(subWidgetContent)
      setIsQuillDisplay(isDeltaFormat)
     }
    }, []);

  const handleClick = () => {
    if (!isDragging) {
      handleEditItemByClick()
      setIsFocused(true)
    }
  }

  const onChangeQuillHandler = (name, contentValue) => {
    if (name === `${subWidgetId}-subwidget`) {
      setSubWidgetContent(contentValue)
    }
  }


   useEffect(() => {
      const handleClickOutside = (event) => {
        if ((isFocused && quillRef.current) && !quillRef?.current.contains(event.target)) {
          setIsFocused(false);
          handleSaveItemByClickOutside();
        }
      };
  
      if (isFocused) {
        setTimeout(() => window.addEventListener('mousedown', handleClickOutside), 1)
      } else {
        window.removeEventListener('mousedown', handleClickOutside);
      }
  
      return () => {
        window.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isFocused]);
  

  if (isQuillDisplay) {
    return (
      editableItemId === subWidgetId
        ? <Box width="100%" ref={quillRef} style={{ cursor: "pointer" }}>
         <LaunchdeckInputTextArea
          name={`${subWidgetId}-subwidget`}
          onChangeHandler={onChangeQuillHandler}
          defaultDelta={subWidgetContent}
          placeholder={"Add your text content here"}
          backgroundColor='white'
          isFocused={isFocused}
        />
       
        </Box>
        : <Box onClick={handleClick} maxW="780px" w='100%'>
          <LaunchdeckDisplayTextArea deltaContent={subWidgetContent} cursor='pointer'/>
        </Box>
    )
  }
  return (
    editableItemId === subWidgetId
      ? <Box width="100%">
        <InputTextAreaExpandableWithFormatting
          autoFocus
          onBlur={handleSaveItemByClickOutside}
          fontSize="1em"
          inputValue={subWidgetContent}
          textAlign={options[optionTypes.ALIGN]}
          backgroundColor="#FDFDFD"
          setSubWidgetContent={setSubWidgetContent}
          onChangeHandler={(e) => setSubWidgetContent(e.target.value)}
          placeholder={"Add your text content here"}
        />
      </Box>
      : <Box onClick={handleClick} padding="10px" maxW="780px" whiteSpace='pre-line' listStylePosition="inside" textAlign={options[optionTypes.ALIGN]} w='100%'>    
        <ReactMarkdown
          children={subWidgetContent ? subWidgetContent : "Lorem ipsum... Add your text content here"}
          remarkPlugins={[remarkGfm]}
        />
      </Box>
  )
}
